import { Box, Link, ListItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams } from 'next/navigation';
import cssStyles from './product_options.module.scss';
import { BorderColor } from "@mui/icons-material";

export interface ColorData {
    name: string;
    hexaCode: string;
}

export interface OptionData {
    configurationIcon: any;
    fabric: any;
    configurationDisplayName: any;
    color: ColorData[];
    productId: string;
    productImage: string;
    productName: string;
}

export interface OptionDetails {
    displayName: string;
    data: OptionData[];

}

export interface VariantData {
    page:string;
    type?: string;
    selectedProductId?: string;
    option: OptionDetails;
    selectedSize?: string;
    hoverState?: any;
    onHover?: any;
    onHoverOut?: any;
    handleCloseProductDetails?: (isCloseMenu: boolean) => void;
    handleSelectedProductDetailId?: (itemId: string) => void;
}
// when we don't send handleCloseProductDetails and handleSelectedProductDetailId then it fallback to link mode 
const ProductOptionComponent: React.FC<VariantData> = ({ page, type, selectedProductId, option,
        selectedSize, hoverState, onHover, onHoverOut ,handleCloseProductDetails,handleSelectedProductDetailId}) => {
            const params = useParams();
            const vendor = params?.vendor || 'nestingale';
            const [selectedProductColor, setSelectedProductColor] = useState('');
            const [selectedProductFabric, setSelectedProductFabric] = useState('');
            const [showAllColors, setShowAllColors] = useState(false);
            const [selectedProductConfig, setSelectedProductConfig] = useState('');
            const [selectedVariant, setSelectedVariant] = useState<OptionData | null>(null);
            console.log('Selected Option:', option);
            console.log('Selected Product ID:', selectedProductId); 
            
            // Handle fabric change
            const handleFabricChange = (fabric: string, productId: string) => {
                setSelectedProductFabric(fabric);
                selectedProductId == productId; // Update selectedProductId as well to trigger re-render
                const variant = option.data.find((opt) => opt.productId === productId);
                setSelectedVariant(variant || null);
                setSelectedProductConfig(variant?.configurationDisplayName); // Ensure config is updated
                console.log(`Selected Fabric for ${productId}:`, fabric);
            };            

            // Handle color change
            const handleColorChange = (colorName: string, productId: string) => {
                setSelectedProductColor(colorName);
                selectedProductId == productId; // Update selectedProductId as well
                const variant = option.data.find((opt) => opt.productId === productId);
                setSelectedVariant(variant || null);
                setSelectedProductConfig(variant?.configurationDisplayName); // Ensure config is updated
                console.log(`Selected Color for ${productId}:`, colorName);
            };
            
            useEffect(() => {
                if (option?.data?.length > 0 && selectedProductId) {
                    const selectedVariant = option.data.find((opt) => opt?.productId === selectedProductId);
                    setSelectedVariant(selectedVariant || null);
            
                    if (selectedVariant) {
                        const colorNames = selectedVariant.color?.map((color) => color.name).join(', ');
                        setSelectedProductColor(colorNames || '');
                        setSelectedProductFabric(selectedVariant.fabric || '');
                        setSelectedProductConfig(selectedVariant.configurationDisplayName || '');
                    } else {
                        // Handle case when no matching variant is found
                        setSelectedProductColor('');
                        setSelectedProductFabric('');
                        setSelectedProductConfig('');
                    }
            
                    console.log('Selected Variant:', selectedVariant);
                }
            }, [option, selectedProductId]);        
            
            console.log("Selected Color:", selectedProductColor);
            console.log("Selected Fabric:", selectedProductFabric);
            console.log("Selected Config:", selectedProductConfig);
            console.log("Selected Size:", selectedSize);
            

    const productOptionByType = (opt: any, productType: any) => {
        switch (productType) {
            case 'chicklets':
                return (
                    <Box component="span" className={cssStyles.chicklet_options} sx={{cursor:'pointer',
                        borderColor: opt?.productId === selectedProductId ? 'primary.main' : '#c4c4c4',
                        color: opt?.productId === selectedProductId ? 'primary.main' : 'inherit',
                        '&:hover': {
                            borderColor: 'primary.main',
                            color: 'primary.main'
                        }
                    }}>
                        {handleCloseProductDetails && handleSelectedProductDetailId ? <a onClick={() => {
                            handleFabricChange(opt?.fabric, opt?.productId)
                            handleCloseProductDetails(false)
                            handleSelectedProductDetailId(opt?.productId)
                        }}>
                            {opt.size ? opt.size : opt.fabric} {/* Display size or fabric */}
                        </a> : <a href={`/showroom/${vendor}/product/${opt?.productId}`} onClick={() => handleFabricChange(opt?.fabric, opt?.productId)}>
                            {opt.size ? opt.size : opt.fabric} {/* Display size or fabric */}
                        </a>}

                    </Box>
                );

            case 'color':
                return (<>{
                    handleCloseProductDetails && handleSelectedProductDetailId ? <a onClick={() => {
                        handleColorChange(opt?.color[0]?.name, opt?.productId)
                        handleCloseProductDetails(false)
                        handleSelectedProductDetailId(opt?.productId)
                    }}>
                        <Box component="span"
                            onMouseEnter={() => onHover && onHover(selectedProductId, opt?.productImage)}
                            onMouseLeave={() => onHoverOut && onHoverOut(selectedProductId)}
                            sx={{
                                background: `linear-gradient(135deg, ${opt.color[0]?.hexaCode} 50%, ${opt.color.length > 1 ? opt.color[1]?.hexaCode : opt.color[0]?.hexaCode} 50%)`
                            }}></Box>
                    </a> : <a href={`/showroom/${vendor}/product/${opt?.productId}`} onClick={() => handleColorChange(opt?.color[0]?.name, opt?.productId)}>
                        <Box component="span"
                            onMouseEnter={() => onHover && onHover(selectedProductId, opt?.productImage)}
                            onMouseLeave={() => onHoverOut && onHoverOut(selectedProductId)}
                            sx={{
                                background: `linear-gradient(135deg, ${opt.color[0]?.hexaCode} 50%, ${opt.color.length > 1 ? opt.color[1]?.hexaCode : opt.color[0]?.hexaCode} 50%)`
                            }}></Box>
                    </a>
                }
                </>
                    
                )
            default:
                return (<>
                    { handleCloseProductDetails && handleSelectedProductDetailId ?<a onClick={()=>{
                         handleCloseProductDetails(false)
                         handleSelectedProductDetailId(opt?.productId)
                    }}>
                      <Box component="span" className={cssStyles["product-option-img"]}
                          sx={{
                              backgroundImage: `url(${opt?.configurationIcon})`
                          }} />
                  </a>
                      :<a href={`/showroom/${vendor}/product/${opt?.productId}`}>
                      <Box component="span" className={cssStyles["product-option-img"]}
                          sx={{
                              backgroundImage: `url(${opt?.configurationIcon})`
                          }} />
                  </a>
                    }</>

                )
        }
    }

    const COLOR_LIMIT = 3;
    const isColorType = type === 'color';
    const hasMoreColors = isColorType && option?.data?.length > COLOR_LIMIT;
    const visibleOptions = hasMoreColors && !showAllColors
        ? option.data.slice(0, COLOR_LIMIT)
        : option.data;

    return (
        <>
            <Box component={'div'} className={`${cssStyles.option} ${cssStyles["type-" + type]} ${page === 'category' && type === 'color' ? cssStyles["category_color_swatch"] : ''}`} sx={{ mt: '10px' }}>
                {page === 'pdp' && <label>{option.displayName === 'Configuration' && `Configuration: ${selectedProductConfig}`}
                {option.displayName === 'Fabric' && `Fabric: ${selectedProductFabric}`}
                {option.displayName === 'Finish' && `Color: ${selectedProductColor}`}
                {option.displayName === 'Size' && `Size: ${selectedSize}`} </label>}
                <div className={cssStyles["option-wrapper"]}>
                    {option && visibleOptions.length > 0 && (
                        visibleOptions.map((opt,index) => {
                            return (
                                <React.Fragment key={index}>
                                    {opt !== null && (
                                        <ListItem component="div" className={`${cssStyles["option-list"]} ${opt?.productId === selectedProductId ? cssStyles.selected : ''}`} disablePadding sx={{
                                            outlineColor: (theme: { palette: { primary: { main: any; }; secondary: { main: any; }; }; }) => opt?.productId === selectedProductId ? theme.palette.primary.main : theme.palette.secondary.main,
                                            '&:hover': {
                                                outlineColor: (theme: { palette: { primary: { main: any; }; secondary: { dark: any; }; }; }) => opt?.productId === selectedProductId ? theme.palette.primary.main : theme.palette.secondary.dark,
                                            },
                                        }}>

                                            <>

                                                {productOptionByType(opt, type)}
                                            </>

                                        </ListItem>
                                    )}
                                </React.Fragment>
                            )
                        })
                    )}
                    {hasMoreColors && (
                        <Box
                            component="button"
                            className={cssStyles["show-more-btn"]}
                            onClick={() => setShowAllColors((prev) => !prev)}
                            sx={{
                                color: 'primary.main',
                                '&:hover': { color: 'primary.dark' },
                            }}
                        >
                            {showAllColors
                                ? 'Show Less'
                                : `+${option.data.length - COLOR_LIMIT} More`}
                        </Box>
                    )}
                </div>
            </Box>
        </>
    );
}

export default ProductOptionComponent;